import React from 'react'
import { Col, Form, FormGroup, Label, Input, ModalBody, Row, FormFeedback, ModalFooter, Button } from 'reactstrap';
import DualListBox from 'react-dual-listbox';
import 'react-dual-listbox/lib/react-dual-listbox.css';

export const FormAntibiogram = (props) => {

    const {
        closeDialogA, loading, handleInputChange, validaciones, antibiotics, onChangeAntibiotics, antibioticsSelected, methodAction, antibiogram, button
    } = props;

    const {
        antibiogram_valid
    } = validaciones;

    return (
        <Form className="" role="form" onSubmit={methodAction}>
            <Row>
                <Col md="12">
                    <FormGroup>
                        <Label className="col-form-label">Antibiograma <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            type="text"
                            className="form-control form-control-sm input-air-primary"
                            name="antibiogram"
                            onChange={handleInputChange}
                            value={antibiogram}
                            autoComplete="off"
                            invalid={antibiogram_valid}
                        />
                        <FormFeedback>Minimo 1 caracter</FormFeedback>
                    </FormGroup>
                </Col>
                <Col sm="12"> <br />
                    <DualListBox
                        selected={antibioticsSelected}//el que va a la derecha
                        simpleValue={false}
                        onChange={onChangeAntibiotics}
                        filterPlaceholder={"Buscar..."}
                        showNoOptionsText={true}
                        canFilter
                        options={antibiotics}//izquierda
                        lang={{
                            // availableFilterHeader: 'Filter available',
                            //  availableHeader: 'Available',
                            moveAllLeft: 'Remover todas las opciones',
                            moveAllRight: 'Agregar todas las opciones',
                            moveLeft: 'Remover la opción seleccionada',
                            moveRight: 'Agregar la opcion seleccionada',
                            moveBottom: 'Move to bottom',
                            // moveDown: 'Move down',
                            //moveUp: 'Move up',
                            ///moveTop: 'Move to top',
                            noAvailableOptions: 'No hay más antibioticos disponibles',
                            noSelectedOptions: 'No se ha seleccionado ningún antibiotico',
                            //selectedFilterHeader: 'Filter selected',
                            // selectedHeader: 'Selected',
                        }}
                    />
                </Col>
            </Row>
            <br />
            <ModalFooter>
                <Button color="primary" type="submit" size="sm" className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}>
                    {button}
                </Button>
                <Button size="sm" color='danger' type="button" onClick={closeDialogA}>
                    Cancelar
                </Button>
            </ModalFooter>
        </Form>
    )
}
